import React, { useState, useEffect } from "react";
import Popup from "../../../Popups/Popup";
import usePostRemoveTradeLot from "../../../Api/usePostRemoveTradeLot";


type Props = {
    id: string | number;
    onRemove: (id) => any;
}

export default function RemoveTradeLot({ id, onRemove }: Props) {
    const [isOpen, setIsOpen] = useState(false);
    const [head, setHead] = useState({title: "Подтвердите действие", description: "Вы уверены что хотите удалить лот?"});
    const [isFinally, setIsFinally] = useState(false);

    const { mutate, isError, isPending, error, isSuccess } = usePostRemoveTradeLot();

    useEffect(() => {
        if (isSuccess) {
            setHead({ title: "Лот успешно удалён" }); setIsFinally(true);
            onRemove(id);
        }
    }, [isSuccess])

    useEffect(() => {
        if (isError) { setHead({ title: "Произошла ошибка..", description: error }); setIsFinally(true) }
    }, [isError])

    return (
        <>
            <button className="removeLotButton" onClick={() => {
                setIsOpen(true)
            }}>
                <svg style={{marginRight: "10px"}} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M20.9999 4H17.8999C17.6678 2.87141 17.0537 1.85735 16.1611 1.12872C15.2686 0.40009 14.1521 0.00145452 12.9999 0L10.9999 0C9.84767 0.00145452 8.7312 0.40009 7.83863 1.12872C6.94606 1.85735 6.33197 2.87141 6.09988 4H2.99988C2.73466 4 2.48031 4.10536 2.29277 4.29289C2.10523 4.48043 1.99988 4.73478 1.99988 5C1.99988 5.26522 2.10523 5.51957 2.29277 5.70711C2.48031 5.89464 2.73466 6 2.99988 6H3.99988V19C4.00147 20.3256 4.52876 21.5964 5.4661 22.5338C6.40344 23.4711 7.67428 23.9984 8.99988 24H14.9999C16.3255 23.9984 17.5963 23.4711 18.5337 22.5338C19.471 21.5964 19.9983 20.3256 19.9999 19V6H20.9999C21.2651 6 21.5194 5.89464 21.707 5.70711C21.8945 5.51957 21.9999 5.26522 21.9999 5C21.9999 4.73478 21.8945 4.48043 21.707 4.29289C21.5194 4.10536 21.2651 4 20.9999 4ZM10.9999 2H12.9999C13.6202 2.00076 14.225 2.19338 14.7315 2.55144C15.238 2.90951 15.6213 3.41549 15.8289 4H8.17088C8.37846 3.41549 8.76178 2.90951 9.26826 2.55144C9.77475 2.19338 10.3796 2.00076 10.9999 2ZM17.9999 19C17.9999 19.7956 17.6838 20.5587 17.1212 21.1213C16.5586 21.6839 15.7955 22 14.9999 22H8.99988C8.20423 22 7.44117 21.6839 6.87856 21.1213C6.31595 20.5587 5.99988 19.7956 5.99988 19V6H17.9999V19Z" fill="black" fill-opacity="0.5" />
                    <path d="M10 17.9994C10.2652 17.9994 10.5196 17.894 10.7071 17.7065C10.8946 17.5189 11 17.2646 11 16.9994V10.9994C11 10.7342 10.8946 10.4798 10.7071 10.2923C10.5196 10.1047 10.2652 9.99939 10 9.99939C9.73478 9.99939 9.48043 10.1047 9.29289 10.2923C9.10536 10.4798 9 10.7342 9 10.9994V16.9994C9 17.2646 9.10536 17.5189 9.29289 17.7065C9.48043 17.894 9.73478 17.9994 10 17.9994Z" fill="black" fill-opacity="0.5" />
                    <path d="M13.9999 17.9994C14.2651 17.9994 14.5195 17.894 14.707 17.7065C14.8945 17.5189 14.9999 17.2646 14.9999 16.9994V10.9994C14.9999 10.7342 14.8945 10.4798 14.707 10.2923C14.5195 10.1047 14.2651 9.99939 13.9999 9.99939C13.7347 9.99939 13.4803 10.1047 13.2928 10.2923C13.1052 10.4798 12.9999 10.7342 12.9999 10.9994V16.9994C12.9999 17.2646 13.1052 17.5189 13.2928 17.7065C13.4803 17.894 13.7347 17.9994 13.9999 17.9994Z" fill="black" fill-opacity="0.5" />
                </svg>
                Удалить</button>

            <Popup
                isOpen={isOpen}
                isFinally={isFinally}
                head={head}
                close={() => {
                    setIsFinally(false);
                    setHead({ title: "Подтвердите действие", description: "Вы уверены что хотите удалить лот?" });
                    setIsOpen(false)
                }}
                loading={isPending}
                actionButtons={[
                    { name: "Да", action: () => mutate(id) },
                    { name: "Нет", action: () => setIsOpen(false) }
                ]}
            />
        </>
    )
}